import { IPD_SCENES } from './tour-scenes-ipd';
import { LAB_SCENES, STORE_SCENES } from './tour-scenes-lab-store';
import { OPD_SCENES } from './tour-scenes-opd';
import type { TourScene } from './tour-types';

export const TOUR_SCENES: readonly TourScene[] = [...OPD_SCENES, ...IPD_SCENES, ...LAB_SCENES, ...STORE_SCENES];
